import { render, staticRenderFns } from "./list-point.vue?vue&type=template&id=d6b239e2"
import script from "./list-point.vue?vue&type=script&lang=js"
export * from "./list-point.vue?vue&type=script&lang=js"
import style0 from "./list-point.vue?vue&type=style&index=0&id=d6b239e2&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports